import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Typography, Container, Box } from "@mui/material";
import DoctorCard from "../components/DoctorCard";
import { fetchDoctorsWithClinicId } from "../services/doctorsRequestApi";
import { usePatientContext } from "../context/PatientContext";
import { serviceGetClinicBasicDetails } from "../services/patientRegistrationRequesApi";
import { handleResponseErrorData } from "../../clinic/utils/commonUtils";


function PatientLanding() {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const clinicId = queryParams.get("clinicId");

  const [doctors, setDoctors] = useState([]);
  const [error, setError] = useState(null);
  const [showDetails, setShowDetails] = useState([]);

  const { patientAppData, getPatientAppData, savePatientAppData } =
    usePatientContext();

    const fetchData = async () => {
      try {
        const response = await fetchDoctorsWithClinicId(clinicId);
        if(response?.status){
          const doctorsData = response.data.doctors
          
          setDoctors(doctorsData);
          setShowDetails(Array(doctorsData.length).fill(false));
          const doctorMap = doctorsData.reduce((acc, doctor) => {
            acc[doctor.doctor_id] = doctor;
            return acc;
          }, {});
          savePatientAppData("doctors", doctorMap);
        } else {
          throw response;
        }
      } catch (error) {
        //setError(error.message);
       // navigate("/404");        
        handleResponseErrorData(error, null);
      }
    };

  useEffect(() => {
      fetchData();
      fetchClinicBasicDetails();
  }, []);

  const fetchClinicBasicDetails = async () => {
    const clinicDetails = getPatientAppData("clinicDetails");
    if (
      !clinicDetails ||
      Object.keys(clinicDetails).length === 0 ||
      clinicDetails.clinicId !== clinicId
    ) {
      const response =  await serviceGetClinicBasicDetails(clinicId);
      if(response?.status){        
        localStorage.setItem("clinicName", response?.data?.clinicName);
        savePatientAppData("clinicDetails", response?.data);
      }else{
        console.error("Error fetching clinic details:", error);
      }
}
  };

  if (error) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="calc(100vh - 120px)"
      >
        <Typography variant="body1" color="error">
          Error fetching doctor list: {error}
        </Typography>
      </Box>
    );
  }

  const toggleDetails = (index) => {
    setShowDetails((prevShowDetails) => {
      const newShowDetails = [...prevShowDetails];
      newShowDetails[index] = !newShowDetails[index];
      return newShowDetails;
    });
  };

  return (
    <>
      <div className=" h-screen flex flex-col md:justify-center">
        <div className=" py-3">
          <img
            src={"../images/new_vitalX_logo.png"}
            className=" h-36 mx-auto "
            alt=""
          />
        </div>
        <Container maxWidth="100%">
          <Typography
            variant="h5"
            component="h1"
            fontWeight="bold"
            textAlign="center"
            color="#1D4ED8"
            mb={4}
          >
            Welcome to the{" "}
            {patientAppData &&
              patientAppData.clinicDetails &&
              patientAppData.clinicDetails.clinicName}
          </Typography>
          <Typography variant="h6" textAlign="center" color="#555" mb={6}>
            Please select the doctor to book an appointment
          </Typography>

          {doctors.length > 0 ? (
            <Box
              display="flex"
              flexWrap="wrap"
              justifyContent="center"
              width={"100%"}
              gap={3}
            >
              {doctors
                .slice()
                .sort((a, b) => a.first_name.localeCompare(b.first_name))
                .map((doctor, index) => (
                  <DoctorCard
                    key={doctor.doctor_id}
                    doctor={doctor}
                    clinicId={clinicId}
                    index={index}
                    showDetails={showDetails}
                    toggleDetails={toggleDetails}
                  />
                ))}
            </Box>
          ) : (
            <Typography variant="subtitle1" textAlign="center">
              No doctors are available at the moment.
            </Typography>
          )}
        </Container>
      </div>
    </>
  );
}

export default PatientLanding;
